import service from "@/store/services/cash-registers-service";

export const state = () => ({
  list: {},
  cashRegister: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegister) => {
    state.cashRegister = cashRegister;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegister) => {
      commit("SET_RESOURCE", cashRegister);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegister) => {
      commit("SET_RESOURCE", cashRegister);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegister) => {
      commit("SET_RESOURCE", cashRegister);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegister: (state) => state.cashRegister,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cashRegister) => ({
      id: cashRegister.id,
      name: `${cashRegister.code} ${cashRegister.name}`,
    }));
  },
};

const cashRegisters = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisters;
